import { columnDefsMap } from "@/components/pages/common/resources-ag-grid/components/column-defs/columnDefsMap";
import { readDataByDotSeparatedString } from "@/components/pages/common/ag-grid/utils/helpers/readDataByDotSeparatedString";
import { AllTypeResourcesData } from "@/store/resources-grid/utils/types/resources";

export const getTaskNameByResourceType = (resource: AllTypeResourcesData) => {
  const targetField = columnDefsMap
    ?.get(resource.resource.resource_type)
    ?.at(0)?.field;

  if (!targetField) {
    return;
  }

  return readDataByDotSeparatedString(targetField, resource);
};
